export default "__VITE_ASSET__DF7kSOb0__"